import { MobileTopGradientAnchor } from '../../constants/mobileTopGradient';

interface MobileTopGradientProps {
  anchor?: MobileTopGradientAnchor;
}

const stylesheet = {
  gradient: {
    [MobileTopGradientAnchor.Viewport]:
      'fixed top-0 left-0 right-0 h-24 bg-gradient-to-b from-semantic-bg-page to-transparent z-[1340] pointer-events-none md:hidden',
    [MobileTopGradientAnchor.ParentBottom]:
      'absolute top-full inset-x-0 h-3 bg-gradient-to-b from-semantic-bg-page to-transparent z-[1340] pointer-events-none md:hidden',
  } satisfies Record<MobileTopGradientAnchor, string>,
};

export function MobileTopGradient({
  anchor = MobileTopGradientAnchor.Viewport,
}: Readonly<MobileTopGradientProps>) {
  return <div className={stylesheet.gradient[anchor]} aria-hidden="true" />;
}
